import React from "react";

const DashRoutesNew = () => {
  return <div>DashRoutesNew</div>;
};

export default DashRoutesNew;
